
import { message } from 'antd';

const messageAlert = (type, msg) => {
    if (type === 'success') {
        return message.success({
            content: msg,
            style: {
                marginTop: '35vh',
                fontSize: 16
            }
        });
    } else if (type === 'error') {
        return message.error({
            content: msg,
            style: {
                marginTop: '35vh',
                fontSize: 16
            }
        });
    }
}


export const utils = {
    messageAlert
};